"use strict";

exports.__esModule = true;
exports.ITEM_TYPES = void 0;
var ITEM_TYPES = {
  DEFAULT: 'DEFAULT',
  STATIC_PAGE: 'STATIC_PAGE',
  STATIC_PAGE_V2: 'STATIC_PAGE_V2',
  STORES_PRODUCT: 'STORES_PRODUCT',
  FORUM_POST: 'FORUM_POST',
  FORUM_CATEGORY: 'FORUM_CATEGORY',
  PRO_GALLERY_ITEM: 'PRO_GALLERY_ITEM',
  BLOG_POST: 'BLOG_POST',
  BLOG_CATEGORY: 'BLOG_CATEGORY'
};
exports.ITEM_TYPES = ITEM_TYPES;